import { AllLLMModels } from "../constants/llmModel";

export type LLMModel = (typeof AllLLMModels)[number];

export function isLLMModel(value: string | undefined): value is LLMModel {
  return (
    value !== undefined && (AllLLMModels as readonly string[]).includes(value)
  );
}
